module.exports = "mutation Favorite ($slug: String!, $type: String = \"campaign\") {\n  favorite (slug: $slug, type: $type)\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/queries/Favorite.graphql
// module id = 88
// module chunks = 1612